import { menuItems } from './menu-items';

export const environment = {
  production: false,
  apiUrl: 'https://api-backoffice.createctrl.com:81/v1',
  defaultResultsPerPage: 10,
  defaultDateFormat: 'dd.MM.yyyy',
  menuItems
};
